// All values come from env files:
//   npm start     -> .env.development
//   npm run build -> .env.production
const config = {
    API_KEY: process.env.REACT_APP_API_KEY,
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    TRAP_API_BASE_URL: process.env.REACT_APP_TRAP_API_BASE_URL,
};

// Fail loudly if an env variable is missing
Object.entries(config).forEach(([key, value]) => {
    if (!value) {
        console.error(`[config] Missing REACT_APP_${key} in .env.${process.env.NODE_ENV}`);
    }
});

export default config;
